import api from "@/lib/api";

export type PostCloudContractsChangePlansEstimateRequest = {
  planCode: string;
  contractNumber: string;
};

export type PostCloudContractsChangePlansEstimateResponse = {
  isUpgrade: boolean;
  oldPlanTranslatedName: string;
  newPlanTranslatedName: string;
  newPlanTerm: string;
  newPlanPrice: number;
  nextInvoiceAt: number;
  newPlanApplyAt: number;
  priceDifference: number;
};

export type PostCloudContractsChangePlansRequest = {
  contractNumber: string;
  planCode: string;
};

export type PostCloudContractsChangePlansResponse = {
  status: string;
  messageType: string;
};

export type PostCloudContractsChangePlansRevokeRequest = {
  contractNumber: string;
};

export type PostCloudContractsChangePlansRevokeResponse = {
  status: string;
  messageType: string;
};

export default {
  // CLOUD容量販売プラン変更の見積もりAPI実行
  postCloudContractsChangePlansEstimate(
    data: PostCloudContractsChangePlansEstimateRequest
  ) {
    return api<
      PostCloudContractsChangePlansEstimateRequest,
      PostCloudContractsChangePlansEstimateResponse
    >({
      endpoint: "cloud-contracts/change-plans/web-api/estimate",
      method: "POST",
      body: data
    });
  },

  // CLOUD容量販売プラン変更の契約変更API実行
  postCloudContractsChangePlans(data: PostCloudContractsChangePlansRequest) {
    return api<
      PostCloudContractsChangePlansRequest,
      PostCloudContractsChangePlansResponse
    >({
      endpoint: "cloud-contracts/change-plans/web-api/change",
      method: "POST",
      body: data
    });
  },

  // CLOUD容量販売プラン変更のキャンセルAPI実行
  postCloudContractsChangePlansRevoke(
    data: PostCloudContractsChangePlansRevokeRequest
  ) {
    return api<
      PostCloudContractsChangePlansRevokeRequest,
      PostCloudContractsChangePlansRevokeResponse
    >({
      endpoint: "cloud-contracts/change-plans/web-api/revoke",
      method: "POST",
      body: data
    });
  }
};
